import React from "react";
import { connect } from "react-redux";
import { Episode as EpisodeView } from "../../design/Episode";
import EpisodeLastPage from "./LastPage";
import ReadingControls from "./ReadingControls";
import EpisodeLocked from "../../design/EpisodeLocked";
import CoinPurchaseDisclaimer from "../../design/EpisodeLocked/CoinPurchaseDisclaimer";
import MobileStoresButtons from "../../design/EpisodeLocked/MobileStoresButtons";
import BalanceAndUnlock from "../../design/EpisodeLocked/BalanceAndUnlock";

import { BlueLink } from "../../design/buttons";

import { actions, signinActions } from "../../../actions";
import { isNotLogged, isLogged, modalPaths } from "../helpers";

class EpisodeDisabled extends React.Component {
  render = () => {
    const {
      isLogged,
      t,
      canUnlock,
      userBalance,
      yourWallet,
      processing,
      ...otherProps
    } = this.props;
    return (
      <EpisodeView onClick={() => false}>
        <EpisodeLocked {...otherProps} {...t}>
          {!isLogged && (
            <div className="t-pt3">
              <BlueLink
                text={t.unlockNotLogged}
                path={`#${modalPaths.signIn}`}
                className="ttu f4"
                onClick={() => false}
              />
            </div>
          )}
          {isLogged && (
            <BalanceAndUnlock
              path={`#${modalPaths.unlock}`}
              userBalance={userBalance}
              yourWallet={yourWallet}
              coinsBalanceText={
                canUnlock ? t.sufficientCoins : t.insufficientCoins
              }
              unlockEpisodeNow={t.unlock}
              enoughCoins={canUnlock}
            />
          )}

          {!isLogged && (
            <CoinPurchaseDisclaimer
              disclaimer={isLogged ? t.insufficientCoins : t.disclaimer}
            />
          )}
          {!canUnlock && <MobileStoresButtons buyCoins={t.unlocking} />}
        </EpisodeLocked>
        <EpisodeLastPage />
      </EpisodeView>
    );
  };
}

const mapState = (state, ownProps) => {
  const userBalance =
    state.currentUser.wallets &&
    parseFloat(
      state.currentUser.wallets.find(wallet => wallet.currency === "pc1")
        .balance
    );

  const canUnlock =
    state.currentEpisode.episode.premium &&
    !state.currentEpisode.episode.paid &&
    state.currentEpisode.episode.price <= userBalance;

  return {
    processing: state.processing,
    img: state.story.thumbnail_url,
    episodeTitle: state.currentEpisode.title,
    storyTitle: state.story.title,
    by: I18n.t("components.unlockModal.by"),
    yourWallet: I18n.t("components.unlockModal.yourWallet"),
    t: I18n.t("components.blankEpisodePage"),
    storySlug: LanguageManager.langPath("stories/" + state.story.slug),
    isLogged: isLogged(),
    episodePrice: state.currentEpisode.episode.price,
    canUnlock,
    userBalance
  };
};

const mapDispatch = (dispatch, ownProps) => ({
  openSigninModalWithCallback: (callback, callbackType, callbackArgs) => {
    dispatch(
      signinActions.openModalWithCallback(callback, callbackType, callbackArgs)
    );
  },
  setLocationHash: hash => {
    dispatch(signinActions.setLocationHash(hash));
  }
});

export default connect(mapState, mapDispatch)(EpisodeDisabled);
